import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import Autocomplete from "@mui/material/Autocomplete";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function AddEmployee() {
  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  const [company_id, setCompanyId] = useState("");
  const [branch_data, setBranch_data] = useState([]);
  const [company_data, setCompany_data] = useState([]);
  const [check, setCheck] = useState(false);
  const [department_data, setDepartment_data] = useState([]);
  const [role_data, setRole_data] = useState([]);
  const classes = useStyles();
  //fetch Company Data
  const getCompanyData = async () => {
    try {
      const data = await api.get("api/master/company");
      //   console.log(data.data);
      setCompany_data(data?.data?.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Branch By id
  const getBranch = async (props, data) => {
    if (data !== null && data !== undefined) {
      const id = {
        id: data.CompanyId,
      };
      //   setCustomer_id(data.CustomerId);
      try {
        const data = await api.post("api/master/branch/refer", id);
        // console.log(data.data.data);
        setBranch_data(data.data.data);
      } catch (e) {
        console.log(e);
      }

      //   console.log(customer_id);
    }
  };
  //fetch Department
  const getDepartment = async () => {
    try {
      const data = await api.get("api/master/department");
      //   console.log(data.data.data);
      setDepartment_data(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Role
  const getRole = async () => {
    try {
      const data = await api.get("api/master/role");
      //   console.log(data.data.data);
      setRole_data(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };

  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getCompanyData();
    getDepartment();
    getRole();
  }, []);
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          พนักงาน
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Employee
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Employee
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            employee_id: "",
            name: "",
            surname: "",
            address: "",
            phone: "",
            fax: "",
            company_id: "",
            password: "",
            confirmpassword: "",
            branch_id: "",
            department: "",
            role: "",
            email: "",
          }}
          validate={(values) => {
            const errors = {};
            if (!values.employee_id || values.employee_id === "") {
              errors.employee_id = " * Required";
            }
            if (!values.name || values.name === "") {
              errors.name = " * Required";
            }
            if (!values.surname || values.surname === "") {
              errors.surname = " * Required";
            }
            if (!company_id || company_id === "") {
              errors.employee_id = " * Required";
            }
            if (!values.branch_id || values.branch_id === "") {
              errors.branch_id = " * Required";
            }
            if (!values.role || values.role === "") {
              errors.role = " * Required";
            }
            if (!values.email || values.email === "") {
              errors.email = " * Required";
            }
            if (values.password !== values.confirmpassword) {
              errors.confirmpassword = 'password do not match'
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                no: values.employee_id,
                name: values.name,
                address: values.address,
                lastname: values.surname,
                phone: values.phone,
                fax: values.fax,
                companyId: company_id,
                branch: values.branch_id,
                depart: values.department,
                email: values.email,
                userLogin: values.employee_id,

                password: values.confirmpassword,
                createId: EmpId,
                roleId: values.role,
              };

              api
                .post("api/employee/create", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "เพิ่มพนักงานสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/Employee");
                      }
                    });
                  });
                })
                .catch((err) => {
                  console.log(err);
                });

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <Grid container>
                <Grid item xs={4} sm={4} md>
                  <div style={{ display: "flex", marginTop: "10px" }}>
                    <TextField
                      name="employee_id"
                      label="EMPLOYEE ID"
                      variant="outlined"
                      placeholder="EMPLOYEE ID"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "50%" }}
                      InputLabelProps={{ shrink: true }}
                      value={values.employee_id}
                      classes={{ root: !values.employee_id ? classes.customOutline : null }}
                      required

                    />
                    <TextField
                      name="password"
                      label="Password"
                      variant="outlined"
                      placeholder="Password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type="password"
                      style={{ width: "50%", marginLeft: "10px" }}
                      InputLabelProps={{ shrink: true }}
                      value={values.password}
                      classes={{ root: !values.password ? classes.customOutline : null }}
                      required
                    />
                  </div>
                  <div style={{ display: "flex", marginTop: '10px' }}>
                    <TextField
                      label="EMAIL ADDRESS"
                      InputLabelProps={{ shrink: true }}
                      placeholder="EMAIL ADDRESS"
                      name="email"
                      style={{
                        width: "50%",

                      }}
                      type="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      classes={{ root: !values.email ? classes.customOutline : null }}
                      required
                    />
                    <TextField
                      name="confirmpassword"
                      label={check ? errors.confirmpassword : 'Confirm Password'}
                      variant="outlined"
                      placeholder="Confirm Password"
                      onChange={handleChange}
                      onBlur={() => setCheck(!check)}
                      error={check}
                      type="password"
                      style={{ width: "50%", marginLeft: "10px" }}
                      InputLabelProps={{ shrink: true }}
                      value={values.confirmpassword}
                      classes={{ root: !values.confirmpassword ? classes.customOutline : null }}
                      required />

                  </div>

                  <div style={{ display: "flex", marginTop: 10 }}>
                    <TextField
                      name="name"
                      label="NAME"
                      variant="outlined"
                      placeholder="NAME"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "50%" }}
                      InputLabelProps={{ shrink: true }}
                      value={values.name}
                      classes={{ root: !values.name ? classes.customOutline : null }}
                      required />

                    <TextField
                      label="SURNAME"
                      InputLabelProps={{ shrink: true }}
                      placeholder="SURNAME"
                      name="surname"
                      style={{
                        width: "50%",
                        marginLeft: "10px",
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.surname}
                      classes={{ root: !values.surname ? classes.customOutline : null }}
                      required />
                  </div>
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <TextField
                      name="address"
                      label="Address"
                      variant="outlined"
                      placeholder="Address"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "50%" }}
                      InputLabelProps={{ shrink: true }}
                      value={values.address}
                    />
                    {errors.address && touched.address && errors.address}

                    <TextField
                      label="Phone"
                      InputLabelProps={{ shrink: true }}
                      placeholder="Phone"
                      name="phone"
                      style={{
                        width: "50%",
                        marginLeft: "10px",
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.phone}
                    />
                    {errors.phone && touched.phone && errors.phone}
                  </div>
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={company_data}
                      style={{ width: "50%" }}
                      getOptionLabel={(option) => option.CompanyName}
                      classes={{ root: !company_id ? classes.customOutline : null }}
                      required
                      onChange={(x, y) => {
                        if (y !== null) {
                          setCompanyId(y.CompanyId);
                          getBranch(x, y);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          name="company_id"
                          label="Company"
                          variant="outlined"
                          placeholder="Company"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          InputLabelProps={{ shrink: true }}
                          value={values.company_id}
                          {...params}
                          fullWidth
                        />
                      )}
                    />

                    <FormControl
                      sx={{ width: "50%", marginLeft: "10px" }}
                      classes={{ root: !values.branch_id ? classes.customOutline : null }}
                      required                    >
                      <InputLabel>Branch</InputLabel>
                      <Select
                        name="branch_id"
                        label="Branch"
                        value={values.branch_id}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="" disabled>
                          <em>เลือก Branch</em>
                        </MenuItem>
                        {branch_data.map((option, index) => {
                          return (
                            <MenuItem key={index} value={option.BranchId}>
                              {option.BranchName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <FormControl
                      sx={{ width: "50%" }}
                      classes={{ root: !values.department ? classes.customOutline : null }}
                      required                     >
                      <InputLabel>Department</InputLabel>
                      <Select
                        name="department"
                        label="Department"
                        value={values.department}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="" disabled>
                          <em>เลือก Department</em>
                        </MenuItem>
                        {department_data.map((option, index) => {
                          return (
                            <MenuItem key={index} value={option.DepartmentId}>
                              {option.DepartmentdName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl
                      sx={{ width: "50%", marginLeft: "10px" }}
                      classes={{ root: !values.role ? classes.customOutline : null }}
                      required                       >
                      <InputLabel>Role</InputLabel>
                      <Select
                        name="role"
                        label="Role"
                        value={values.role}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="" disabled>
                          <em>เลือก Role</em>
                        </MenuItem>
                        {role_data.map((option, index) => {
                          return (
                            <MenuItem key={index} value={option.RoleId}>
                              {option.RoleName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </Grid>
              </Grid>
              <div style={{ marginTop: 10 }}>
                <Button
                  type="button"
                  variant="outlined"
                  style={{
                    color: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  onClick={history.goBack}
                >
                  back
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  style={{
                    background: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting && <CircularProgress size={22} />}
                  {!isSubmitting && "SAVE"}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
